"use strict";

import _ from 'lodash';
import request from 'superagent';
import url from 'url';
import {thenCallback} from "./utils";
import config from './config';

const auth = require('./auth');

class CentralConfigError extends Error {
	constructor(message, status, response) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
	}
}

class CentralConfigClient {
	constructor(options) {
		options = Object.assign({
			token: config.get('token'),
			url: config.get('CentralConfigurationURL'),
			hierarchy: [],
		}, options);
		this.options = options;
		this.configServerURL = url.parse(options.url);
		this.apiPrefix = options.apiPrefix || ['api', 'v1'];
		this.hierarchy = _.castArray(options.hierarchy);
	}

	url(query) {
		let u = _.clone(this.configServerURL);
		u.pathname = '/' + [].concat(this.apiPrefix, this.hierarchy).join('/');
		u.query = Object.assign({}, u.query, query);
		return url.format(u);
	}

	get token() {
		return this.options.token;
	}

	get headers() {
		return {'x-access-token': this.token, 'Cache-Control': 'no-cache'};
	}

	request(method, body, callback) {
		let r = request(method, this.url()).set(this.headers);
		if (body) {
			r.send(body);
		}
		return thenCallback(r, callback);
	}

	/**
	 * Save value to CentralConfig server
	 *
	 * @param key
	 * @param value
	 * @param callback
	 * @returns {Promise}
	 */
	put(key, value, callback) {
		return this.request('PUT', {changes: {[key]: value}}, callback);
	}

	/**
	 * Alias for put.
	 *
	 * @param key
	 * @param value
	 * @param callback
	 * @returns {Promise}
	 * @deprecated
	 */
	set(key, value, callback) {
		return this.put(key, value, callback);
	}

	patch(key, value, callback) {
		return this.request('PATCH', {changes: {[key]: value}}, callback);
	}

	get(key, callback) {
		let self = this;
		let r = this.request('GET')
			.then(
				function (response) {
					let value;
					if (key) {
						value = _.get(response.body, key);
					} else {
						value = response.body;
					}
					return value;
				},
				function (e) {
					self.constructor.processError(e);
				}
			);
		return thenCallback(r, callback);
	}

	static processError(e) {
		let {status, message, response} = e;
		if (response && response.body) {
			message = response.body;
		} else if (!message) {
			if (status === 404) {
				message = 'Unknown config variable';
			} else if (status === 403) {
				message = 'Access denied';
			}
		}
		throw new CentralConfigError(message, status, response);
	}
}

export default CentralConfigClient;
